import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderPopupComponent} from './header-popup/header-popup.component';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDialogModule} from '@angular/material/dialog';


@NgModule({
  declarations: [
    HeaderPopupComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressBarModule,
    MatDialogModule
  ],
  exports: [
    HeaderPopupComponent
  ]
})
export class HeaderPopupModule { }
